import dayjs from "dayjs";

export const baseRanges: any = {
  昨天: [
    dayjs()
      .subtract(1, 'days')
      .startOf('day'),
    dayjs()
      .subtract(1, 'days')
      .endOf('day'),
  ],
  今天: [
    dayjs()
      .startOf('day'),
    dayjs()
      .endOf('day'),
  ],
  近7天: [
    dayjs()
      .subtract(6, 'days')
      .startOf('day'),
    dayjs().endOf('day'),
  ],
  近30天: [
    dayjs()
      .subtract(29, 'days')
      .startOf('day'),
    dayjs().endOf('day'),
  ],
  近90天: [
    dayjs()
      .subtract(89, 'days')
      .startOf('day'),
    dayjs().endOf('day'),
  ],
  本周: [dayjs().startOf('week'), dayjs().endOf('day')],
  上周: [
    dayjs()
      .subtract(1, 'weeks')
      .startOf('week'),
    dayjs()
      .subtract(1, 'weeks')
      .endOf('week'),
  ],
  本月: [dayjs().startOf('month'), dayjs().endOf('day')],
  上月: [
    dayjs()
      .subtract(1, 'months')
      .startOf('month'),
    dayjs()
      .subtract(1, 'months')
      .endOf('month'),
  ],
  // 今年: [
  //   dayjs()
  //     .startOf('year'),
  //   dayjs().endOf('day'),
  // ],
  去年: [
    dayjs()
      .subtract(1, 'years')
      .startOf('year'),
    dayjs()
      .subtract(1, 'years')
      .endOf('year'),
  ],
};